import { motion } from "framer-motion";
import NavigationColored from './../components/NavigationColored';
import serviceImage from './../../assets/images/services/dedicated-desk.jpg';

const pageVariants = {
    initial: { scale: 0.9, opacity: 0 },
    in: { scale: 1, opacity: 1 },
    out: { scale: 0.9, opacity: 0 }
};

const pageTransition = {
    type: "tween",
    ease: "easeInOut",
    duration: 0.5,
};
const DedicatedDesk = () => {
    return (
        <motion.div
            initial="initial"
            animate="in"
            exit="out"
            variants={pageVariants}
            transition={pageTransition}
        >
            <NavigationColored />
            <div style={{ marginTop: '4em' }}></div>
            <section className="service">
                <div className="container">
                    <div className="section-title" style={{ marginBottom: "50px" }}>
                        <h1>Dedicated Desk</h1>
                        <p>“Your Desk. Your Space. Every Day.”</p>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 col-md-6">
                            <p align="justify">A dedicated desk provides a reserved workspace in a shared environment, offering privacy and consistency. Perfect for freelancers, remote employees, or small business owners, it ensures you always have your own personal workstation—complete with storage space, ergonomic furniture, and access to all shared amenities like high-speed internet, meeting rooms, pantry facilities, and printing services. Unlike hot-desking, a dedicated desk gives you the stability to leave your equipment securely overnight while still benefiting from the collaborative energy of a co-working community. It’s an ideal balance of independence and networking, designed to boost productivity in a professional setting.</p>
                        </div>
                        <div className="col-lg-6 col-md-6 sub-services">
                            {/* <ul>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Save time & reduce overheads</li>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Scale up or down easily</li>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Improve team productivity</li>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Impress clients with professional space</li>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Plug-and-play setup</li>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />No maintenance worries</li>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Nearby landmarks, parking, metro/train stations</li>
                            </ul> */}
                            <img className="service-image" src={serviceImage} alt="service Image"/>
                        </div>
                    </div>
                </div>
            </section>
        </motion.div>
    )
}

export default DedicatedDesk
